import {
  Badge,
  Button,
  Dropdown,
  Icon,
  Menu,
  Popover,
  Rate,
  Tooltip,
} from 'antd';
import React from 'react';
import WorkerCell from '../../../../../../../components/WorkerCell/WorkerCell';
import { RequestsUserWrapper } from '../../../../RequestsUserWrapper/RequestsUserWrapper';
import { workerKeys } from '../../../../../../../components/WorkerCell/constants';
import moment from 'moment';
import {
  declOfNum,
  dspxDiffDays,
} from '../../../../../../../helpers/dspx-utils';
import {
  CreationMethod,
  ExecuteDateWithActions,
} from '../../../../../../../components/requestComponents';
import { createFullAddress } from '../../../../../../../helpers/createFullAddress';
import { ReactComponent as MasterIcon } from '../../../../../../../resource/Master.svg';
import { ReactComponent as MasterСontractorIcon } from '../../../../../../../resource/MasterСontractor.svg';
import AttachmentsPanelContainer from '../../../../../../attachments-panel.container';
import {
  PossWarrantyIcon,
  RubleIcon,
  OrderIcon,
  UrgentIcon,
  ToolIcon,
  BadWorkIcon,
  RetryIcon,
  AttachIcon,
} from '../../../../../../../resource/icons';
import MarksPanel from '../../../../../../../components/marks-panel';
import { RequestInvoiceBlock } from '../../../../../../../components/requestComponents/InvoiceManager';
import { Priority } from '../../../../../../../components/requestComponents';

const isContractor = (speciality) => speciality?.toLowerCase() === 'подрядчик';

const statusIds = {
  new: 1,
  inWork: 2,
  closed: 3,
  cancelled: 4,
  done: 5,
  doneCallHuman: 6,
};

const doneStatusIds = new Set([statusIds.done, statusIds.doneCallHuman]);

const notWarrantyId = 0;

export const getColumnsTable = () => [
  {
    title: 'Номер',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    align: 'right',
    render: (text, record) => {
      const canChange = false;
      const canRatingChange = false;

      return (
        <div style={{ position: 'relative', minWidth: '80px' }}>
          {record.externalNumber && (
            <div
              style={{
                fontSize: '12px',
                whiteSpace: 'nowrap',
              }}
            >
              {record.externalNumber}
            </div>
          )}
          <div style={{ whiteSpace: 'nowrap' }}>
            {record.hasAttachment && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Popover
                  // visible={this.state.attachementPanelVisible === record.id}
                  // onVisibleChange={this.handleAttachementPanelVisibleChange}
                  content={
                    <AttachmentsPanelContainer
                      showWarrantyDocs={record.garantyId === notWarrantyId}
                      request={record.id}
                      // needUpdate={this.state.needUpdateAttachments}
                      // resetNeedUpdate={this.resetNeedUpdateAttachments}
                      hasattachment={record.hasAttachment}
                      // changeEntityHasAttachmentProp={
                      //   this.changeRequestHasAttachmentProp
                      // }
                      hideUploadBox={!canChange}
                      hideActions={!canChange}
                    />
                  }
                  title={
                    <div style={{ color: '#0995ed', fontSize: 18 }}>
                      <Icon type="paper-clip" />
                      <span> Вложения</span>
                    </div>
                  }
                  trigger="click"
                  placement="right"
                >
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Вложения"
                  >
                    <Button
                      ghost
                      shape="circle"
                      style={{
                        position: 'relative',
                        top: '-0px',
                        left: '-8px',
                      }}
                    >
                      <AttachIcon
                        grey={(!record.hasAttachment).toString()}
                        style={{ height: '18px' }}
                      />
                    </Button>
                  </Tooltip>
                </Popover>
              </span>
            )}

            {record.creationMethod && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <CreationMethod
                  record={record}
                  // methods={this.props.creationMethods}
                  iconStyle={{
                    position: 'relative',
                    left: '-5px',
                    top: '-3px',
                    height: '24px',
                  }}
                />
              </span>
            )}
            <span
              style={{
                color: '#0995ed',
                fontWeight: record.firstViewDate ? 'normal' : 'bold',
              }}
            >
              {text}
            </span>
          </div>
          <div>
            <Tooltip title={record.ratingDescription}>
              <span
                className={canRatingChange ? 'dspx-ref' : ''}
                style={{ color: '#ccc' }}
              >
                {record.rating === 'б/о' || (
                  <Rate
                    disabled={!canRatingChange}
                    value={
                      isNaN(record.rating) ? 0 : parseInt(record.rating, 10)
                    }
                    style={{ fontSize: 10 }}
                    // onChange={(e) =>
                    //   this.handleRatingChange(
                    //     e,
                    //     record.id,
                    //     isNaN(record.rating) ? 0 : parseInt(record.rating, 10)
                    //   )
                    // }
                  />
                )}
              </span>
            </Tooltip>
          </div>
        </div>
      );
    },
  },
  // ...(this.props.requestsFailedValue
  //   ? [
  //       {
  //         title: 'Причина',
  //         dataIndex: 'reason',
  //         key: 'reason',
  //         width: 200,
  //         render: (text, record) => {
  //           if (record.reason) {
  //             return (
  //               <div
  //                 style={{
  //                   color: 'red',
  //                   fontSize: '13px',
  //                   fontWeight: '500',
  //                 }}
  //               >
  //                 {text}
  //               </div>
  //             );
  //           }
  //         },
  //       },
  //     ]
  //   : []),
  {
    title: 'Создание',
    key: 'create_time',
    width: 190,
    align: 'left',
    render: (text, record) => {
      const canChange = false;
      // const { CanChangeStatus } = this.props.userInfo;
      const { CanChangeStatus } = {};
      const canMarksChange = false;

      const df = record.doneDate
        ? dspxDiffDays(record.doneDate, record.createTime)
        : dspxDiffDays(0, record.createTime);
      const bgf = '#d8f2ff';
      const fgf = '#0d6aa2';
      const tlf =
        'Время выполнения ' +
        (df > 0 ? df + declOfNum(df, [' день', ' дня', ' дней']) : '?');

      const displayItem = (statusId, recordStatusId) => {
        const additionalCheckResult = canChange
          ? !doneStatusIds.has(recordStatusId) ||
            statusId === statusIds.closed ||
            statusId === statusIds.inWork
          : statusId === statusIds.inWork;

        return statusId !== recordStatusId && additionalCheckResult;
      };

      // const mi = this.state.statuses.map(
      //   (el) =>
      //     displayItem(el.id, record.statusId) && (
      //       <Menu.Item
      //         key={el.id}
      //         rid={record.id}
      //       >
      //         <span>{el.description}</span>
      //       </Menu.Item>
      //     )
      // );
      const mi = [];
      const menuItems =
        record.garantyId === -999 // 0
          ? [
              ...mi,
              <Menu.Divider key="div1" />,
              <Menu.Item
                key={'pg'}
                rid={record.id}
              >
                <PossWarrantyIcon
                  style={{ height: '20px', verticalAlign: 'text-bottom' }}
                />
                <span>Возможно гарантия</span>
              </Menu.Item>,
            ]
          : mi;
      const menu = <Menu>{menuItems}</Menu>;

      return (
        <div style={{ paddingRight: 20 }}>
          <div style={{ whiteSpace: 'nowrap' }}>
            <span style={{ fontSize: '14px', marginRight: '10px' }}>
              {moment(record.createTime).format('DD.MM.YYYY HH:mm')}
            </span>
            {!isNaN(df) && df !== 0 && record.statusId !== 4 && (
              <Tooltip
                title={tlf}
                mouseLeaveDelay={0}
              >
                <div
                  style={{
                    top: '4px',
                    right: '4px',
                    backgroundColor: bgf,
                    color: fgf,
                    borderRadius: '12px',
                    padding: '1px 8px',
                    fontSize: '12px',
                    textAlign: 'center',
                    cursor: 'default',
                    minWidth: '20px',
                    display: 'inline-block',
                  }}
                >
                  {df > 0 ? df : '?'}
                </div>
              </Tooltip>
            )}
          </div>
          <div>
            <span
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Popover
                placement="right"
                content={
                  <MarksPanel
                    marks={{
                      // immediate: this.props.userInfo.CanChangeImmediate,
                      // chargeable: this.props.userInfo.CanChangeChargeable,
                      byClient: record.byClient,
                    }}
                    marksValue={{
                      immediate: record.isImmediate,
                      chargeable: record.isChargeable,
                      internal: record.isInternal,
                    }}
                  />
                }
                title={
                  <div>
                    <Icon
                      type="tag"
                      style={{
                        position: 'relative',
                        top: 3,
                        fontSize: 20,
                        color: '#ccc',
                        marginRight: '7px',
                        cursor: 'pointer',
                      }}
                    />{' '}
                    Признаки
                  </div>
                }
                trigger="click"
                // visible={
                //   canMarksChange && this.state.marksPanelVisibleId === record.id
                // }
                // onVisibleChange={(visible) => {
                //   this.handleMarksPanelVisibleChange(record.id, visible);
                // }}
              >
                {!record.isRetry &&
                  !record.isImmediate &&
                  !record.isChargeable &&
                  !record.isInternal &&
                  !record.badWork &&
                  canChange &&
                  (this.props.userInfo.CanChangeImmediate ||
                    this.props.userInfo.CanChangeChargeable) && (
                    <Tooltip
                      mouseLeaveDelay={0}
                      title="Признаки"
                    >
                      <Icon
                        type="tag"
                        style={{
                          position: 'relative',
                          top: 5,
                          fontSize: 20,
                          color: '#ddd',
                          marginRight: '7px',
                          cursor: 'pointer',
                        }}
                      />
                    </Tooltip>
                  )}
                {record.isRetry && (
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Повторная"
                  >
                    <RetryIcon
                      style={{
                        marginRight: '7px',
                        height: '25px',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                )}
                {record.isImmediate && (
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Аварийная"
                  >
                    <UrgentIcon
                      style={{
                        marginRight: '7px',
                        height: '25px',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                )}
                {record.isChargeable && (
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Платная"
                  >
                    <RubleIcon
                      style={{
                        marginRight: '7px',
                        height: '25px',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                )}
                {record.isInternal && (
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Внутренняя"
                  >
                    <ToolIcon
                      style={{
                        marginRight: '7px',
                        height: '25px',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                )}
                {record.paidServiceRequestId && (
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Заказ"
                  >
                    <OrderIcon
                      style={{
                        marginRight: '7px',
                        height: '25px',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                )}
                {record.badWork && (
                  <Tooltip
                    mouseLeaveDelay={0}
                    title="Для обсуждения"
                  >
                    <BadWorkIcon
                      style={{
                        marginRight: '7px',
                        height: '25px',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                )}
              </Popover>
            </span>
            {CanChangeStatus ? (
              <Dropdown
                overlay={menu}
                trigger={['click']}
              >
                <Tooltip
                  mouseEnterDelay={0.6}
                  mouseLeaveDelay={0}
                  title="Изменить статус"
                >
                  <span
                    className={'dspx-ref'}
                    style={{
                      fontSize: '11px',
                      cursor: 'pointer',
                      color: '#0995ed',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {record.status}
                  </span>
                </Tooltip>
              </Dropdown>
            ) : (
              <span style={{ fontSize: '11px', color: '#0995ed' }}>
                {record.status}
              </span>
            )}
            {!canChange || record.existNote || (
              <Tooltip
                mouseEnterDelay={0.6}
                mouseLeaveDelay={0}
                title="нет комментариев"
              >
                <span
                  style={{
                    marginLeft: '10px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#ff7600',
                    cursor: 'pointer',
                  }}
                >
                  !
                </span>
              </Tooltip>
            )}

            {/* {record.isChargeable && (
              <RequestInvoiceBlock
                canChange={canChange}
                request={record}
                style={{ marginTop: 10 }}
              />
            )} */}
          </div>
        </div>
      );
    },
  },
  {
    title: 'Адрес',
    key: 'full_address',
    width: 180,
    render: (_text, record) => {
      const canAddressChange = false;

      return (
        <div>
          {/* {this.props.filterState.valueCheckedStage && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              {record.stageAddressLifeCycleCurrent && (
                <Tooltip title="Стадия помещения текущая">
                  <div
                    style={{
                      color: '#17A9F1',
                      fontFamily: 'Segoe UI',
                      fontSize: '12px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {record.stageAddressLifeCycleCurrent.name}
                  </div>
                </Tooltip>
              )}
              {record.acceptanceStatusAddressLifeCycle && (
                <Tooltip title="Результат приемки помещения">
                  <div
                    style={{
                      color: '#17A9F1',
                      fontFamily: 'Segoe UI',
                      fontSize: '12px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {record.acceptanceStatusAddressLifeCycle.name}
                  </div>
                </Tooltip>
              )}
            </div>
          )} */}
          <div>
            <div style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
              <Tooltip title={canAddressChange ? 'Изменить адрес' : ''}>
                <span
                  className={canAddressChange ? 'dspx-ref' : ''}
                  style={{
                    fontSize: '12px',
                    marginRight: '15px',
                    whiteSpace: 'nowrap',
                    cursor: canAddressChange ? 'pointer' : 'default',
                  }}
                >
                  {createFullAddress(record)}
                </span>
              </Tooltip>
            </div>
            {(record.entrance || record.floor) && (
              <div
                style={{
                  fontSize: '12px',
                  color: '#888',
                  whiteSpace: 'nowrap',
                }}
              >
                {record.entrance && ` подъезд: ${record.entrance} `}
                {record.floor && `этаж: ${record.floor}`}
              </div>
            )}
            {record.regionName && (
              <div
                style={{
                  fontSize: '12px',
                  color: '#8e8e8e',
                  whiteSpace: 'nowrap',
                }}
              >
                {`мкр. ${record.regionName}`}
              </div>
            )}
          </div>
        </div>
      );
    },
  },
  {
    title: <div style={{ whiteSpace: 'nowrap' }}>Услуга</div>,
    key: 'service',
    width: 170,
    render: (text, record) => {
      const canServiceChange = false;

      return (
        <div>
          <div
            style={{
              color: '#17a9f1',
              fontSize: '13px',
              fontWeight: '500',
            }}
          >
            <Tooltip
              title="Услуга"
              mouseLeaveDelay={0}
            >
              <span
                className={canServiceChange ? 'dspx-ref' : ''}
                style={{
                  marginRight: '10px',
                  cursor: canServiceChange ? 'pointer' : 'default',
                }}
              >
                {record.parentService}
              </span>
            </Tooltip>
          </div>
          <div>
            <Tooltip
              title="Причина"
              mouseLeaveDelay={0}
            >
              <span
                rid={record.id}
                parent_service={record.parentService}
                parent_service_id={record.parentServiceId}
                service_id={record.serviceId}
                className={canServiceChange ? 'dspx-ref' : ''}
                style={{
                  fontSize: '12px',
                  marginRight: '10px',
                  cursor: canServiceChange ? 'pointer' : 'default',
                }}
              >
                {(record.service && record.service) || 'не указана'}
              </span>
            </Tooltip>
          </div>
        </div>
      );
    },
  },
  {
    title: 'Выполнение',
    key: 'execute_time',
    width: 220,
    render: (text, record) => {
      const canChange = false;
      const canCalendarChange = false;

      const dr = record.doneDateTime
        ? dspxDiffDays(record.doneDateTime, record.executeDateTime)
        : dspxDiffDays(0, record.executeDateTime);

      const bgr = '#d8f2ff';
      const fgr = '#0d6aa2';
      const tlr =
        'Просрочено на ' +
        (dr > 0
          ? dr +
            declOfNum(dr, [' день', ' дня', ' дней']) +
            (record.executeTime ? '' : ' / Нет даты назначения')
          : '?');

      const createCalendarTooltipTitle = ({ request, canChange }) => {
        if (!canChange) return '';

        return request.taskId
          ? moment(record.taskStart).format('DD.MM.YYYY HH:mm') +
              moment(record.taskEnd).format(' - HH:mm')
          : 'Добавить в календарь';
      };

      return (
        <div style={{ whiteSpace: 'nowrap' }}>
          <ExecuteDateWithActions
            request={record}
            requestsPage
            canChange={canChange}
          />

          {(record.taskId || canCalendarChange) && (
            <Tooltip
              title={createCalendarTooltipTitle({
                request: record,
                canChange: canCalendarChange,
              })}
              mouseLeaveDelay={0}
            >
              <span
                className={record.statusId === 3 ? '' : 'dspx-ref-hidden'}
                style={{
                  marginRight: '0px',
                  whiteSpace: 'nowrap',
                  cursor: canCalendarChange ? 'pointer' : 'default',
                }}
              >
                <Icon
                  type="calendar"
                  style={{
                    color: record.taskId ? '#ff921e' : '#aaa',
                    marginRight: '8px',
                  }}
                />
              </span>
            </Tooltip>
          )}
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Priority
              record={record}
              iconStyle={{
                color: '#0995ed',
                cursor: canChange ? 'pointer' : 'default',
                marginRight: '8px',
              }}
            />
          </span>

          {!isNaN(dr) && dr > 0 && record.statusId !== 4 && (
            <Tooltip
              title={tlr}
              mouseLeaveDelay={0}
            >
              <Badge
                count={
                  <Icon
                    type="fire"
                    theme="twoTone"
                    style={{ fontSize: 20 }}
                    twoToneColor={dr > 14 ? '#ff0003' : '#f44336'}
                  />
                }
              >
                <div
                  style={{
                    top: '4px',
                    right: '4px',
                    backgroundColor: bgr,
                    color: fgr,
                    borderRadius: '12px',
                    padding: '4px 8px',
                    fontSize: '12px',
                    textAlign: 'center',
                    minWidth: '20px',
                    display: 'inline-block',
                    cursor: 'pointer',
                  }}
                >
                  {dr > 0 ? dr : '?'}
                </div>
              </Badge>
            </Tooltip>
          )}
          {record.doneDate && (
            <Tooltip
              title="Выполнена"
              mouseLeaveDelay={0}
            >
              <div
                style={{
                  fontSize: '12px',
                  marginRight: '10px',
                  color: '#0995ed',
                  whiteSpace: 'nowrap',
                }}
              >
                <svg
                  style={{ color: '#aaa', marginRight: '8px' }}
                  className="icon icon-clipboard"
                >
                  <use xlinkHref="#icon-clipboard"></use>
                </svg>
                {record.doneDateTime &&
                  moment(record.doneDateTime).format('DD.MM.YYYY HH:mm')}
              </div>
            </Tooltip>
          )}

          {record.closeDate && (
            <Tooltip title="Закрыта">
              <div
                style={{
                  fontSize: '12px',
                  color: '#000',
                  whiteSpace: 'nowrap',
                  marginRight: '10px',
                }}
              >
                <Icon
                  type="close-square"
                  style={{ marginRight: '8px', color: '#aaa' }}
                />
                {record.closeDateTime &&
                  moment(record.closeDateTime).format('DD.MM.YYYY HH:mm')}
              </div>
            </Tooltip>
          )}
        </div>
      );
    },
  },
  {
    title: 'Мастер/Исполнитель/УК',
    key: 'master-executer',
    width: 220,
    render: (text, record) => {
      const canChange = false;

      return (
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <Tooltip
            mouseEnterDelay={0.6}
            mouseLeaveDelay={0}
            title={
              isContractor(record.master?.speciality)
                ? 'Мастер подрядчик'
                : 'Мастер'
            }
            placement="topLeft"
          >
            <div>
              <WorkerCell
                request={record}
                considerPaidId
                canChange={canChange}
                renderIcon={() =>
                  isContractor(record.master?.speciality) ? (
                    <Icon component={MasterСontractorIcon} />
                  ) : record?.master ? (
                    <Icon component={MasterIcon} />
                  ) : null
                }
              />
            </div>
          </Tooltip>
          <Tooltip
            mouseEnterDelay={0.6}
            mouseLeaveDelay={0}
            title={
              isContractor(record.executer?.speciality)
                ? 'Исполнитель подрядчик'
                : 'Исполнитель'
            }
            placement="topLeft"
          >
            <div>
              <WorkerCell
                request={record}
                canChange={canChange}
                workerKey={workerKeys.executor}
                renderIcon={() =>
                  isContractor(record.executer?.speciality) ? (
                    <Icon component={MasterСontractorIcon} />
                  ) : record?.executer ? (
                    <Icon component={MasterIcon} />
                  ) : null
                }
              />
            </div>
          </Tooltip>

          {record.companyName && (
            <div style={{ fontSize: '11px', color: '#009fdc' }}>
              {record.companyName}
            </div>
          )}
        </div>
      );
    },
  },

  {
    title: 'Заявитель/Создатель',
    key: 'applicant_and_creator',
    width: 160,
    render: (text, record) => {
      return (
        <div
          style={{
            fontSize: '13px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <WorkerCell
            request={record}
            workerKey={workerKeys.applicant}
            renderContent={({ withCursor }) => (
              <RequestsUserWrapper
                request={record}
                withCursor={withCursor}
                contentType="applicant"
              />
            )}
            workerObj={{
              fullName: record.clientName,
              phones: record.contactPhones?.split(', '),
            }}
          />
          <WorkerCell
            request={record}
            workerKey={workerKeys.creator}
            renderContent={({ withCursor }) => (
              <RequestsUserWrapper
                request={record}
                withCursor={withCursor}
                contentType="creator"
              />
            )}
            workerObj={{
              fullName: record.createUser?.fullName,
              phones: record.createUser?.phone?.split(', '),
              specialityName: record.createUser?.specialityName,
            }}
            canCall={
              record?.createUser?.speciality?.toLowerCase() !== 'диспетчер' &&
              record?.createUser?.phone
            }
          />
        </div>
      );
    },
  },
];
